var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ReplyIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 63,
    glyphHeight: 42
  }), React.createElement("path", {
    d: "M22.9783 42C21.8978 42 20.845 41.6203 20.0415 40.8861L1.21558 23.6844C-0.405194 22.2034 -0.405194 19.7985 1.21558 18.3175L20.0415 1.11576C21.2329 0.0271974 23.006 -0.301902 24.5714 0.293008C26.1229 0.887918 27.1342 2.25495 27.1342 3.79918V11.1153C34.3653 11.9887 53.025 15.6341 62.4311 30.5068C63.3315 31.9372 63.1514 33.6586 61.9739 34.9117C60.7964 36.1522 58.954 36.5572 57.2917 35.9496C42.774 30.6461 31.6917 29.8613 27.1342 29.798V38.19C27.1342 39.7343 26.1229 41.114 24.5714 41.6962C24.0588 41.8861 23.5186 41.9873 22.9783 41.9873V42ZM6.11947 21.0009L21.593 35.1395V28.5449C21.593 26.4564 23.38 24.7982 25.6519 24.7476C29.8216 24.6717 40.5852 25.0514 55.283 29.8486C46.0017 18.8491 30.2372 16.4948 25.3056 16.0265C23.1861 15.824 21.593 14.2038 21.593 12.2545V6.87499L6.11947 21.0136V21.0009Z",
    fill: "black"
  }));
};
export var ReplyIconGlyph = function (props) {
  return React.createElement(ReplyIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};